import { Injectable } from '@angular/core';
import {
  AuthStatePersistenceService,
  createFrom,
  EventService,
  ProductSearchService,
  StatePersistenceService,
} from '@spartacus/core';
import { map, skip, switchMap } from 'rxjs/operators';
import { NavigationEvent } from '@spartacus/storefront';
import { EMPTY } from 'rxjs';
import { Ga4GgListingPageEvent } from './ga4-gg-listing-page-event';

@Injectable({
  providedIn: 'root',
})
export class Ga4GgListingPageEventBuilder {
  constructor(
    private eventService: EventService,
    private productSearchService: ProductSearchService,
    private authStatePersistenceService: AuthStatePersistenceService,
    private currencyStatePersistenceService: StatePersistenceService
  ) {
    const searchResults$ = this.productSearchService.getResults().pipe(skip(1));

    const ga4GgListingPageCleanUpEventSource = this.eventService.get(NavigationEvent).pipe(
      switchMap((navigationEvent: NavigationEvent) => {
        if (navigationEvent?.semanticRoute === 'category' || navigationEvent?.semanticRoute === 'search') {
          return searchResults$.pipe(
            map((searchResults) =>
              createFrom(Ga4GgListingPageEvent, {
                ecommerce: null,
              })
            )
          );
        } else {
          return EMPTY;
        }
      })
    );

    eventService.register(Ga4GgListingPageEvent, ga4GgListingPageCleanUpEventSource);

    const ga4GgListingPageEventSource = this.eventService.get(NavigationEvent).pipe(
      switchMap((navigationEvent: NavigationEvent) => {
        if (navigationEvent?.semanticRoute === 'category' || navigationEvent?.semanticRoute === 'search') {
          return searchResults$.pipe(
            map((searchResults) =>
              createFrom(Ga4GgListingPageEvent, {
                event: 'view_item_list',
                visitor_type: authStatePersistenceService.isUserLoggedIn() ? 'logged_in' : 'logged-out',
                ecommerce: {
                  item_list_name: navigationEvent?.semanticRoute === 'category' ? 'Categorylist' : 'Search result page',
                  currency: currencyStatePersistenceService.readStateFromStorage({ key: 'currency' }) as string,
                  items: this.getItemsFromSearchResults(searchResults, navigationEvent),
                },
              })
            )
          );
        } else {
          return EMPTY;
        }
      })
    );

    eventService.register(Ga4GgListingPageEvent, ga4GgListingPageEventSource);
  }

  private getItemsFromSearchResults(searchResults, navigationEvent: NavigationEvent) {
    const items: {
      item_id?: string;
      item_name?: string;
      price?: number;
      item_list_name?: string;
      quantity?: number;
    }[] = [];

    searchResults?.products?.forEach((product, indexProduct) => {
      const item = {
        item_id: product.code,
        item_name: product.modelMark,
        price: product.price?.value,
        item_list_name: navigationEvent?.semanticRoute === 'category' ? 'Categorylist' : 'Search result page',
        quantity: 1,
      };

      product.categoryHierarchy?.forEach((category, indexCategory) => {
        item['item_category' + (indexCategory.toString() !== '0' ? (indexCategory + 1).toString() : '')] =
          category.name;
      });

      Object.keys(item).forEach((key) => (item[key] === undefined ? delete item[key] : {}));

      items.push(item);
    });

    return items;
  }
}
